export const STEP_TITLES = [
  'Request accepted',
  'Request persisted',
  'Provider, model and settings resolved',
  'Parameters checked and prepared',
  'Request sent to provider',
  'Provider response checked',
  'Converted to AssemblyAI-first',
  'Normalizers applied in order',
  'Quality checks evaluated',
  'Normalized transcript returned',
];
